import { prefix, ajax } from './common';

export async function addProductToCart(product_id, qty) {
  return await ajax({
    url: prefix + '/cart/add/' + product_id,
    data: {
      qty
    }
  });
}

export async function getCartFillerProducts() {
  return await ajax({
    url: prefix + '/cart-filler',
  });
}